export default __webpack_public_path__ + "static/media/Cang Jei's Serrated Gibe.b447d85d.jpg";